/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card .card-title h6{font-size:22px;color:var(--blue-medium);font-weight:700}.card .card-body .border-card-right{border-right:solid 1px var(--border-form)}@media only screen and (max-width:767px){.card .card-title h6{font-size:16px}.card .card-body .border-card-right{border-right:0;border-bottom:solid 1px var(--border-form)}}"];
export { styles as styles };
